<div class="success-dialog">
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="center center">
      <div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="center center" class="content">
        <div class="mat-h3">
          <span class="mdi mdi-check-decagram color-primary"></span>
          {{data.message}}
        </div>
        <div class="mat-body width-100">
          <span [innerHTML]="data.subMessage"></span>
        </div>
      </div>
      <br>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="width-100">
        <button class="primary" (click)="onSubmit($event)" mat-stroked-button>Close</button>
      </div> 
    </div>
  </mat-dialog-content>
</div>
